<div class="rating-group">
  <app-template-editor-rating-group-item
    *ngFor="let item of ratingGroup.items; trackBy: trackBy"
    [ratingGroupItem]="item"
    (ratingGroupItemChange)="onRatingItemChange($event)"
    (makeDefault)="makeDefault(item)"
  >
  </app-template-editor-rating-group-item>
</div>
